import axios from "axios";
import { rsa } from "../libs/rsa";
export const userTree = () => {
  return axios.request({
    url: "/api/organization/user/tree",
    method: "get",
    params: {}
  });
};
export const findByNameTree = name => {
  return axios.request({
    url: "/api/organization/findOrganizationByName",
    method: "get",
    params: {
      name
    }
  });
};
export const saveOrganization = params => {
  return axios.request({
    url: "/api/organization/saveOrganization",
    method: "post",
    data: {
      ...params
    }
  });
};
export const updateOrganization = params => {
  return axios.request({
    url: "/api/organization/updateOrganization",
    method: "post",
    data: {
      ...params
    }
  });
};
export const saveUserOrganizationAssociate = params => {
  console.log(params);
  const res = rsa(params, ["mobile", "userEmail"]);
  // const res = rsa("mobile", mobile);
  return axios.request({
    url: "/api/userOrganizationAssociate/saveMember",
    method: "post",
    data: {
      ...params,
      ...res
    }
  });
};
export const deleteUserOrganizationAssociateById = params => {
  return axios.request({
    url: "/api/userOrganizationAssociate/organization/quit",
    method: "post",
    data: {
      ...params
    }
  });
};
export const updateUserOrganizationAssociate = params => {
  return axios.request({
    url: "/api/userOrganizationAssociate/updateOrganization",
    method: "post",
    data: {
      ...params
    }
  });
};
export const getTagList = params => {
  return axios.request({
    url: "/api/tag/page",
    method: "get",
    params
  });
};
export const tagListNoPage = params => {
  return axios.request({
    url: "/api/tag/list",
    method: "get",
    params
  });
};
export const saveTag = params => {
  return axios.request({
    url: "/api/tag/saveTag",
    method: "post",
    data: {
      ...params
    }
  });
};
export const updateTag = params => {
  return axios.request({
    url: "/api/tag/updateTag",
    method: "post",
    data: {
      ...params
    }
  });
};
export const userUpdate = params => {
  const res = rsa(params, ["userEmail"]);
  return axios.request({
    url: "/api/userOrganizationAssociate/updateMember",
    method: "post",
    data: {
      ...params,
      ...res
    }
  });
};
export const userDelete = params => {
  return axios.request({
    url: "/api/userOrganizationAssociate/deleteMember",
    method: "post",
    data: {
      ...params
    }
  });
};
export const userList = params => {
  return axios.request({
    url: "/api/userOrganizationAssociate/member/page",
    method: "get",
    params
  });
};
export const userListNew = params => {
  return axios.request({
    url: "/api/userOrganizationAssociate/joinMember/page",
    method: "get",
    params
  });
};
export const userListNoPage = params => {
  return axios.request({
    url: "/api/userOrganizationAssociate/user/list",
    method: "get",
    params
  });
};
export const tagFindByName = params => {
  return axios.request({
    url: "/api/tag/findByName",
    method: "get",
    params
  });
};
export const findTagById = params => {
  return axios.request({
    url: "/api/tag/findTagById",
    method: "get",
    params
  });
};
export const findOrganizationById = params => {
  return axios.request({
    url: "/api/organization/findOrganizationById",
    method: "get",
    params
  });
};
export const unitRoles = params => {
  return axios.request({
    url: "/api/role/unitRoles",
    method: "get",
    params
  });
};
export const acceptInvite = params => {
  return axios.request({
    url: "/api/sso/org/link/accept",
    method: "get",
    params
  });
};
export const listUserAssignedRoles = params => {
  return axios.request({
    url: "/api/role/listUserAssignedRoles",
    method: "get",
    params
  });
};
export const queryRoleMembers = params => {
  return axios.request({
    url: "/api/role/queryRoleMembers",
    method: "get",
    params
  });
};
export const queryTagMembers = params => {
  return axios.request({
    url: "/api/role/queryTagMembers",
    method: "get",
    params
  });
};
export const listRoleAssignedEntities = params => {
  return axios.request({
    url: "/api/role/listRoleAssignedEntities",
    method: "get",
    params
  });
};
export const listTagAssignedEntities = params => {
  return axios.request({
    url: "/api/role/listTagAssignedEntities",
    method: "get",
    params
  });
};
export const addRole = params => {
  return axios.request({
    url: "/api/role/addRole",
    method: "post",
    data: {
      ...params
    }
  });
};
export const setRole = params => {
  return axios.request({
    url: "/api/role/setRole",
    method: "post",
    data: {
      ...params
    }
  });
};
export const deleteRole = roleId => {
  return axios.request({
    url: `/api/role/deleteRole/${roleId}`,
    method: "post",
    data: {}
  });
};
export const saveTagAssociate = params => {
  return axios.request({
    url: "/api/tagAssociate/saveTagMember",
    method: "post",
    data: {
      ...params
    }
  });
};
export const initialInvite = params => {
  return axios.request({
    url: "/api/userInvitation/inviteMember",
    method: "post",
    data: {
      ...params
    }
  });
};
export const deleteTagById = params => {
  return axios.request({
    url: "/api/tag/deleteTagById",
    method: "post",
    data: {
      ...params
    }
  });
};
export const deleteTagAssociateById = params => {
  return axios.request({
    url: "/api/tagAssociate/deleteTagMember",
    method: "post",
    data: {
      ...params
    }
  });
};
export const modMemberDepartmentBatch = params => {
  return axios.request({
    url: "/api/userOrganizationAssociate/modMemberDepartmentBatch",
    method: "post",
    data: {
      ...params
    }
  });
};
export const disableMember = params => {
  return axios.request({
    url: "/api/userOrganizationAssociate/disableMember",
    method: "post",
    data: {
      ...params
    }
  });
};
export const enableMember = params => {
  return axios.request({
    url: "/api/userOrganizationAssociate/enableMember",
    method: "post",
    data: {
      ...params
    }
  });
};
export const quitMember = data => {
  return axios.request({
    url: "/api/userOrganizationAssociate/quitMember",
    method: "post",
    data
  });
};
export const assignUsersForRole = data => {
  return axios.request({
    url: "/api/role/assignUsersForRole",
    method: "post",
    data
  });
};
export const assignTagsForRole = data => {
  return axios.request({
    url: "/api/role/assignTagsForRole",
    method: "post",
    data
  });
};
export const assignEntitiesForTag = data => {
  return axios.request({
    url: "/api/role/assignEntitiesForTag",
    method: "post",
    data
  });
};
export const assignRolesForUser = data => {
  return axios.request({
    url: "/api/role/assignRolesForUser",
    method: "post",
    data
  });
};
export const syncRolesToDownstream = (downstream, increment) => {
  return axios.request({
    url: `/api/v2/binding/syncRolesToDownstream/${downstream}/${increment}`,
    method: "post"
  });
};
export const ensureIWorkMirrorUnit = () => {
  return axios.request({
    url: `/api/v2/binding/ensureIWorkMirrorUnit`,
    method: "post"
  });
};
export const syncOneUserToDownstream = params => {
  const res = rsa(params, ["mobile"]);
  return axios.request({
    url: `/api/v2/binding/syncOneUserToDownstream`,
    method: "post",
    data: {
      ...params,
      ...res
    }
  });
};
export const deleteOrganizationById = data => {
  return axios.post("/api/organization/deleteOrganizationById", data);
};
export const memberAdd = data => {
  return axios.post("/api/gig/addressBook/member/add", data);
};
export const updateMember = data => {
  return axios.post("/api/gig/addressBook/member/update", data);
};
export const recoverMember = data => {
  return axios.post("/api/userOrganizationAssociate/recoverMember", data);
};
export const ipTablesDelete = data => {
  return axios.post("/api/ipTables/delete", data);
};
export const departmentTree = data => {
  return axios.get("/api/gig/addressBook/department/tree", {
    params: data
  });
};
export const treeWithMember = data => {
  return axios.get("/api/gig/addressBook/department/tree/withMember", {
    params: data
  });
};
export const assignableApps = data => {
  return axios.get("/api/gig/addressBook/member/assignableApps", {
    params: data
  });
};
export const memberDetail = data => {
  return axios.get("/api/gig/addressBook/member/detail", {
    params: data
  });
};
export const memberPage = data => {
  return axios.get("/api/gig/addressBook/member/page", {
    params: data
  });
};
export const positionDetail = data => {
  return axios.get("/api/gig/addressBook/position/detail", {
    params: data
  });
};
export const tagAssociatePage = data => {
  return axios.get("/api/tagAssociate/page", {
    params: data
  });
};

//通讯录模版下载
export const exportExcelTXL = () => {
  return axios.request({
    url: "/api/file/addressBookDownLoad",
    method: "get",
    responseType: "blob"
  });
};